import React from 'react'

import { useAppDispatch, useAppSelector } from '@/stores/hooks.ts'
import { sbpPaymentsActions, sbpPaymentSelectors } from '@/stores/slices/sbp-payments-slice.ts'
import { ToggleGroup } from '@/components'
import { SbpPaymentMethod } from '@/types.ts'

export const TypeFilter = (): React.ReactElement => {
  const typeFilter = useAppSelector(sbpPaymentSelectors.sbpType)
  const dispatch = useAppDispatch()

  const handleTypeChange = (_: unknown, item: SbpPaymentMethod) => {
    dispatch(sbpPaymentsActions.setFilter({ filterKey: 'sbpType', filterValue: item }))
  }
  return (
    <ToggleGroup<SbpPaymentMethod>
      items={[
        { title: 'C2B', value: 'C2B' },
        { title: 'B2B', value: 'B2B' },
        { title: 'B2C', value: 'B2C' },
      ]}
      value={typeFilter}
      onChange={handleTypeChange}
    />
  )
}
